import {toast} from 'react-toastify';
import i18n from 'i18n/i18n';
import {browserHistory} from 'routing/browserHistory';
import {AuthRoutePaths} from 'routing/Routes';

export function showUnauthorizedError() {
  toast.error(i18n.t('Error loading data, no access'), {className: 'skip-fade'});
  browserHistory.push(AuthRoutePaths.signIn.url);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function showCommunicationError(err: any) {
  if (err && err.status === 401) {
    showUnauthorizedError();
    return;
  }
  console.error('Error when loading data. Exception: ', err);
  const content = await err.json();
  console.log('Error response: ', content);
  if (content && content.errors && content.errors.length > 0) {
    for (const error of content.errors) showError(error);
  } else {
    toast.error(
      content.ErrorMessage ? i18n.t(content.ErrorMessage) : i18n.t('Error when loading data, try again later'),
      {
        className: 'skip-fade',
      }
    );
  }
}

export function showError(message: string) {
  toast.error(message, {className: 'skip-fade'});
}

export function showSuccess(message: string) {
  toast.success(message, {className: 'skip-fade'});
}

export function showNotFoundToast() {
  toast.error(i18n.t('Element not found'), {className: 'skip-fade'});
}
